export default __webpack_public_path__ + "static/media/user_guide_for_Annual_Return.d68a6557.pdf";